import { object, ObjectSchema } from "yup";
import { requestDateValidator, truckNameValidator } from "./stepOneSchema";

export interface TruckDetailsSchemaProps {
	truckName: string;
	requestDate: string;
}

export const truckDetailsSchemaObj = {
	truckName: truckNameValidator,
	requestDate: requestDateValidator
};

export const truckDetailsSchema: ObjectSchema<TruckDetailsSchemaProps> = object(truckDetailsSchemaObj);
